// hooks/useYandexMaps.ts
import { useEffect, useState } from 'react';

export const useYandexMaps = (apiKey: string) => {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        // Если скрипт уже загружен, просто помечаем как готовый
        if (document.querySelector(`script[data-yandex-key="${apiKey}"]`)) {
            setReady(true);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${apiKey}`;
        script.async = true;
        script.dataset.yandexKey = apiKey;

        script.onload = () => setReady(true);
        script.onerror = () => console.error('Не удалось загрузить скрипт Яндекс Карт');

        document.body.appendChild(script);

        // Очистка при размонтировании
        return () => {
            document.body.removeChild(script);
        };
    }, [apiKey]);

    return ready;
};
